import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/hivemqdatahub')({
  beforeLoad: () => {
    throw redirect({ to: '/datahub' })
  },
})
